import router from 'src/router'
import {
    TweenLite
} from 'gsap'

class Pill {

    constructor(config) {

        this.tweenObj = {
            alpha: 0
        };

        this.ctx = config.ctx;
        this.lineWidth = config.lineWidth;
        this.pixelRatio = config.pixelRatio;
        this.radius = config.radius;
        this.points = config.points;

    }

    draw(progress) {

        this.ctx.save();

        this.ctx.beginPath();
        this.ctx.strokeStyle = "#FFF";
        this.ctx.lineWidth = this.lineWidth * this.pixelRatio;

        // top arc
        this.ctx.arc(this.points.top.x, this.points.top.y, this.radius * this.pixelRatio, Math.PI, 0);

        // right line
        this.ctx.lineTo(this.points.right.top.x, this.points.right.top.y);
        this.ctx.lineTo(this.points.right.bottom.x, this.points.right.bottom.y);

        // bottom arc
        this.ctx.arc(this.points.bottom.x, this.points.bottom.y, this.radius * this.pixelRatio, 0, Math.PI);

        // left
        this.ctx.moveTo(this.points.left.top.x, this.points.left.top.y);
        this.ctx.lineTo(this.points.left.bottom.x, this.points.left.bottom.y);

        this.ctx.globalAlpha = this.tweenObj.alpha;

        this.ctx.stroke();
        this.ctx.restore();
    }

    show() {
        TweenLite.to(this.tweenObj, 1, {
            alpha: 1
        });
    }

    hide() {
        TweenLite.to(this.tweenObj, 0.5, {
            alpha: 0,
            ease: 'Quad.easeIn'
        });
    }


    // input states

    up() {
        TweenLite.to(this.tweenObj, 0.5, {
            alpha: 1
        });
    }

    down() {
        TweenLite.to(this.tweenObj, 0.1, {
            alpha: 0.4
        });
    }

}

export default Pill